import { Box, Center, Spinner, Text } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import CommentListItem from './CommentListItem/CommentListItem';

interface Props extends PaginationListProps<CommentListItem> {
  onDeleteClicked: (comment: CommentListItem) => void;
  onEditClicked: (comment: CommentListItem) => void;
}

const CommentsLoadedList: FC<Props> = ({
  items,
  currentPage,
  pageCount,
  setPage,
  onDeleteClicked,
  onEditClicked,
  isFetching,
}) => {
  const { t } = useTranslation();

  if (items.length === 0) {
    return (
      <AppCard p="20px">
        <Center>
          <Text>{t('listIsEmpty')}</Text>
        </Center>
      </AppCard>
    );
  }

  return (
    <>
      {items.map((comment, index) => (
        <Box mb={index < items.length - 1 ? '20px' : '0'} key={comment.id}>
          <CommentListItem
            comment={comment}
            onDeleteClicked={() => onDeleteClicked(comment)}
            onEditClicked={() => onEditClicked(comment)}
          />
        </Box>
      ))}
      {isFetching && (
        <Center pt="20px">
          <Spinner />
        </Center>
      )}
      {!isFetching && currentPage < pageCount && (
        <Text
          mt="10px"
          onClick={() => setPage(currentPage + 1)}
          fontWeight={700}
          cursor="pointer"
          _hover={{ textDecoration: 'underline' }}
        >
          {t('loadMore')}
        </Text>
      )}
    </>
  );
};

export default CommentsLoadedList;
